import axios from 'axios'
import { MDBInput } from 'mdbreact'
import React, { useEffect } from 'react'
import { useState } from 'react'


const InventarioProductosConfiguracion = ({ setFuncion, productoSelect, baseUrl, data, setData }) => {
    const [alerta, setAlerta] = useState(0)

    useEffect(() => {
        setAlerta(productoSelect.alerta)
    }, [])

    const peticionPut = async () => {
        try {
            let f = new FormData()
            f.append('nombre', 'ALERTAS_INVENTARIO')
            f.append('alerta', alerta)
            f.append('id', productoSelect.id)
            f.append('alertaPUT', "alertaPUT")
            f.append('METHOD', 'PUT')
            const respuesta = await axios.post(baseUrl, f)
            setFuncion('ver')
            let dataNueva = data
            dataNueva.map(item => {
                if (item.id === productoSelect.id) {
                    item.alerta = alerta
                }
            })
            setData(dataNueva)
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div>
            <h5>Alertas:</h5>
            <div className="row">

                <div className="col-md-4"> <br></br><p className="estados Rojo">Por agotarse</p></div>
                <div className="col-md-8"><MDBInput label="Minimo Stock " outline
                    value={alerta}
                    onChange={e => setAlerta(e.target.value)} />
                </div>

                <div className="col text-center">
                    <button
                        onClick={peticionPut}
                        className="btn boton_estandar"
                    >Actualizar
                    </button>
                </div>
            </div>
        </div>
    )
}

export default InventarioProductosConfiguracion